import React, { useEffect } from "react";
import "./styles.m.css";
import { GA, DeepBI } from "../../../../integrations";
export default function GoogleSearch() {
  useEffect(() => {
    const script = document.createElement("script");
    document.head.append(script);
    script.src = "https://cse.google.com/cse.js?cx=f43c85eeddd886b94";
  }, []);

  const barredResultsRenderedCallback = (gname, query, promoElts, resultElts) => {
    document.querySelector(".main-content").classList.add("search-page");
    GA.customEvent("vikatan-search", "search-click", query);
    DeepBI.PingSearchClicked({ q: query });
    if (global.webengage && global.webengage.track) {
      global.webengage.track("vikatan-search", { searchInput: query });
    }
  };
  global.__gcse || (global.__gcse = {});
  global.__gcse.searchCallbacks = {
    web: {
      rendered: barredResultsRenderedCallback
    }
  };

  return <div className="gcse-search" data-webSearchResultSetSize="6" />;
}
